export class SelectItem {

    value: any;
    label: string;
    
    constructor(label: string, value: any) {
        this.label = label;
        this.value = value;
    }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/selectItem.ts